import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import Lodder from "../../../components/Lodder";
import CustomerService from "../../../services/CustomerService";
import { useState, useRef, useEffect } from "react";
import { notification } from "antd";
import { Link, useNavigate ,useParams} from "react-router-dom";
import customerServices from "../../../services/CustomerService";
import { Select } from "antd";
import { State } from "country-state-city";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { CloseOutlined } from "@ant-design/icons";
import CryptoJS from "crypto-js";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const MultiMemberLLCRegister = () => {
  // #region State Initilization
  const encryptedQueryParam = useParams().userData;
  const [showPassword, setShowPassword] = useState(false);
  const [showLodder, setShowLodder] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const [model, setModal] = useState(false);
  const [login, setLogin] = useState(false);
  const [isLogined, setIsLogined] = useState(false);
  const navigate = useNavigate();
  const [signature, setSignature] = useState("");
  const [signatureValidation, setSignatureValidation] = useState({
    isValid: true,
    message: "",
  });
  const [businessName, setBusinessName] = useState("");
  const [businessNameValidation, setBusinessNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine1Validation, setAddressLine1Validation] = useState({
    isValid: true,
    message: "",
  });
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine2Validation, setAddressLine2Validation] = useState({
    isValid: true,
    message: "",
  });
  const [city, setCity] = useState("");
  const [cityValidation, setCityValidation] = useState({
    isValid: true,
    message: "",
  });
  const [state, setState] = useState("Washington");
  const [stateValidation, setStateValidation] = useState({
    isValid: true,
    message: "",
  });
  const [zipCode, setZipCode] = useState("");
  const [zipCodeValidation, setZipCodeValidation] = useState({
    isValid: true,
    message: "",
  });
  const [customerFirstName, setCustomerFirstName] = useState("");
  const [customerFirstNameValidation, setCustomerFirstNameValidation] =
    useState({ isValid: true, message: "" });
  const [customerLastName, setCustomerLastName] = useState("");
  const [customerLastNameValidation, setCustomerLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [email, setEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState({
    isValid: true,
    message: "",
  });
  const [signFirstName, setSignFirstName] = useState("");
  const [signFirstNameValidation, setSignFirstNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [signLastName, setSignLastName] = useState("");
  const [signLastNameValidation, setSignLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [password, setPassword] = useState("");
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: true,
    message: "",
  });

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState({
    isValid: true,
    message: "",
  });
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [loginPassword, setLoginPassword] = useState("");

  const [passwordLoginValidation, setLoginPasswordValidation] = useState({
    isValid: false,
    message: "",
  });
  // #endregion

  // #region Validitation Functions
  const ValidateBusinessName = (value) => {
    if (!value.trim()) {
      setBusinessNameValidation({
        isValid: false,
        message: "Business name is required",
      });
      return false;
    } else if (value.length > 100) {
      setBusinessNameValidation({
        isValid: false,
        message: "Business name not more than 100 character",
      });
      return false;
    } else {
      setBusinessNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateAddressLine1 = (value) => {
    if (!value.trim()) {
      setAddressLine1Validation({
        isValid: false,
        message: "Address line 1 is required",
      });
      return false;
    } else if (value.length > 100) {
      setAddressLine1Validation({
        isValid: false,
        message: "Address line 1 not more than 100 character",
      });
      return false;
    } else {
      setAddressLine1Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateAddressLine2 = (value) => {
    if (value.length > 100) {
      setAddressLine2Validation({
        isValid: false,
        message: "Address line 2 not more than 100 character",
      });
      return false;
    } else {
      setAddressLine2Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateCity = (value) => {
    if (!value.trim()) {
      setCityValidation({
        isValid: false,
        message: "City is required",
      });
      return false;
    } else if (value.length > 100) {
      setCityValidation({
        isValid: false,
        message: "City not more than 100 character",
      });
      return false;
    } else {
      setCityValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateState = (value) => {
    if (!value.trim()) {
      setStateValidation({
        isValid: false,
        message: "State is required",
      });
      return false;
    } else if (value.length > 100) {
      setStateValidation({
        isValid: false,
        message: "State not more than 100 character",
      });
      return false;
    } else {
      setStateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateZipCode = (value) => {
    if (!value.trim()) {
      setZipCodeValidation({
        isValid: false,
        message: "Zip code is required",
      });
      return false;
    } else if (value.length !== 5) {
      setZipCodeValidation({
        isValid: false,
        message: "Please enter a valid zip code",
      });
      return false;
    } else {
      setZipCodeValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateCustomerFirstName = (value) => {
    if (!value.trim()) {
      setCustomerFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setCustomerFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setCustomerFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateCustomerLastName = (value) => {
    if (!value.trim()) {
      setCustomerLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setCustomerLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setCustomerLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateSignFirstName = (value) => {
    if (!value.trim()) {
      setSignFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setSignFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setSignFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateSignLastName = (value) => {
    if (!value.trim()) {
      setSignLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setSignLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setSignLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const ValidateEmail = (value) => {
    if (!value.trim()) {
      setEmailValidation({ isValid: false, message: "Email is required" });
      return false;
    } else if (value.length > 100) {
      setEmailValidation({
        isValid: false,
        message: "Email not more than 50 character",
      });
      return false;
    } else if (!IsValidEmail(value)) {
      setEmailValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
      return false;
    } else {
      setEmailValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePassword = (value) => {
    if (!value.trim()) {
      setPasswordValidation({
        isValid: false,
        message: "Password is required",
      });
      return false;
    } else if (value.length < 6) {
      setPasswordValidation({
        isValid: false,
        message: "Please enter a minimum of 6 characters",
      });
      return false;
    } else {
      setPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateConfirmPassword = (value) => {
    if (!value.trim()) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Confirm password is required",
      });
      return false;
    } else if (value !== password) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Password and confirm password must be same",
      });
      return false;
    } else {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateLoginPassword = (value) => {
    if (!value.trim()) {
      setLoginPasswordValidation({
        isValid: false,
        message: "Password is required",
      });
      return false;
    } else {
      setLoginPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < imageData.data.length; i += 4) {
      if (imageData.data[i + 3] !== 0) {
        setSignatureValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    }

    setSignatureValidation({
      isValid: false,
      message: "Signature is required",
    });
    return false;
  };
  // #endregion

  // #region Field Change Functions
  const handleBusinessNameChange = (event) => {
    setBusinessName(event.target.value);
    ValidateBusinessName(event.target.value);
  };
  const handleAddressLine1Change = (event) => {
    setAddressLine1(event.target.value);
    ValidateAddressLine1(event.target.value);
  };
  const handleAddressLine2Change = (event) => {
    setAddressLine2(event.target.value);
    ValidateAddressLine2(event.target.value);
  };
  const handleCityChange = (event) => {
    setCity(event.target.value);
    ValidateCity(event.target.value);
  };
  const handleStateChange = (selectedOption) => {
    setState(selectedOption);
    ValidateState(selectedOption);
  };
  const handleZipCodeChange = (event) => {
    setZipCode(event.target.value);
    ValidateZipCode(event.target.value);
  };
  const handleCustomerFirstNameChange = (event) => {
    setCustomerFirstName(event.target.value);
    ValidateCustomerFirstName(event.target.value);
  };
  const handleCustomerLastNameChange = (event) => {
    setCustomerLastName(event.target.value);
    ValidateCustomerLastName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    ValidateEmail(event.target.value);
    if (IsValidEmail(event.target.value)) {
      setShowLodder(true);
      customerServices
        .CheckCustomerExist(event.target.value)
        .then((response) => {
          if (response.status && response.resultData > 0) {
            setModal(true);
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response.data.Message,
          });
        })
        .finally(() => {
          setShowLodder(false);
        });
    }
  };
  const handleEmailBlur = () => {
    if (emailValidation.isValid && email.trim()) {
      handleAutoSubmit();
    }
  };
  const handleAutoSubmit = () => {
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    ValidateEmail(email);
    if (emailValidation.isValid) {
      var customer = {
        customerFirstName: customerFirstName,
        customerLastName: customerLastName,
        businessName: businessName,
        email: email,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        zipCode: zipCode,
        signature: signature.split(",")[1],
        signFirstName: signFirstName,
        signLastName: signLastName,
        password: password,
      };
      CustomerService.Register(customer).catch((error) => {});
    }
  };
  const handleSignFirstNameChange = (event) => {
    setSignFirstName(event.target.value);
    ValidateSignFirstName(event.target.value);
  };
  const handleSignLastNameChange = (event) => {
    setSignLastName(event.target.value);
    ValidateSignLastName(event.target.value);
  };
  const handlePasswordChange = (event) => {
    if (event.target.value === confirmPassword) {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
    }
    setPassword(event.target.value);
    ValidatePassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    ValidateConfirmPassword(event.target.value);
  };
  const handleLoginPasswordChange = (event) => {
    setLoginPassword(event.target.value);
    ValidateLoginPassword(event.target.value);
  };

  // #endregion

  // #region Submit Functions
  const handleFormSubmit = () => {
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    ValidateBusinessName(businessName);
    ValidateCustomerFirstName(customerFirstName);
    ValidateCustomerLastName(customerLastName);
    ValidateEmail(email);
    ValidateAddressLine1(addressLine1);
    ValidateAddressLine2(addressLine2);
    ValidateCity(city);
    ValidateState(state);
    ValidateZipCode(zipCode);
    ValidateSignFirstName(signFirstName);
    ValidateSignLastName(signLastName);
    ValidatePassword(password);
    ValidateConfirmPassword(confirmPassword);
    ValidateSignature();
    if (
      ValidateBusinessName(businessName) &&
      ValidateCustomerFirstName(customerFirstName) &&
      ValidateCustomerLastName(customerLastName) &&
      ValidateEmail(email) &&
      ValidateAddressLine1(addressLine1) &&
      ValidateAddressLine2(addressLine2) &&
      ValidateCity(city) &&
      ValidateState(state) &&
      ValidateZipCode(zipCode) &&
      ValidateSignFirstName(signFirstName) &&
      ValidateSignLastName(signLastName) &&
      ValidatePassword(password) &&
      ValidateConfirmPassword(confirmPassword) &&
      ValidateSignature()
    ) {
      setShowLodder(true);
      customerServices
        .CheckBusinessExist(email, businessName)
        .then((response) => {
          if (response.status && response.resultData > 0) {
            notification.error({
              message: "You already take service for this business",
            });
          } else {
            const data = {
              customerId: customerId,
              customerFirstName: customerFirstName,
              customerLastName: customerLastName,
              businessName: businessName,
              email: email,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              city: city,
              state: state,
              zipCode: zipCode,
              signature: signature,
              signFirstName: signFirstName,
              signLastName: signLastName,
              password: password,
              isLogined: isLogined,
            };
            const encryptedUserData = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              process.env.REACT_APP_SECRET_KEY
            ).toString();
            const userData = encodeURIComponent(encryptedUserData);
            navigate(`/MultiMemberPayment/${userData}`);
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response.data.Message,
          });
        })
        .finally(() => {
          setShowLodder(false);
        });
    }
  };
  const handleLoginFormSubmit = () => {
    ValidateLoginPassword(loginPassword);
    if (passwordLoginValidation.isValid) {
      var customerCredentials = {
        email: email,
        password: loginPassword,
      };
      CustomerService.LoginCustomerForAddingNewBusiness(customerCredentials)
        .then((response) => {
          if (response.status) {
            setIsLogined(true);
            const userId = response.resultData;
            setCustomerId(userId);
            setLogin(false);
            customerServices
              .GetCustomerById(userId)
              .then((response) => {
                if (response.status) {
                  const { resultData } = response;
                  if (resultData !== null) {
                    setCustomerFirstName(resultData.customerFirstName);
                    setCustomerLastName(resultData.customerLastName);
                    setEmail(resultData.email);
                    setPassword(loginPassword);
                    setConfirmPassword(loginPassword);
                    setCustomerFirstNameValidation({
                      isValid: true,
                      message: "",
                    });
                    setCustomerLastNameValidation({
                      isValid: true,
                      message: "",
                    });
                    setEmailValidation({
                      isValid: true,
                      message: "",
                    });
                    setPasswordValidation({
                      isValid: true,
                      message: "",
                    });
                    setConfirmPasswordValidation({
                      isValid: true,
                      message: "",
                    });
                  }
                }
              })
              .catch((error) => {
                notification.error({
                  message: error.response.data.Message,
                });
              });
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response.data.Message,
          });
        });
    }
  };
  // #endregion

  // #region Signature Functions
  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 3;
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = () => {
    setIsDrawing(false);
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL(); // Get the signature as a data URL
    setSignature(signatureData);
    ValidateSignature();
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSignatureValidation({
      isValid: false,
      message: "Signature is required",
    });
  };
  // #endregion

  // #region Other Helper Function
  const usStates = State.getStatesOfCountry("US").map((state) => ({
    value: state.name,
    label: state.name,
  }));
  const handlelogin = () => {
    setModal(false);
    setLogin(true);
  };
  // #endregion
  useEffect(() => {
    document.title = "Foundry Law - Multi-Member LLC Onboarding";
    if (encryptedQueryParam) {
      const decryptedData = CryptoJS.AES.decrypt(
        decodeURIComponent(encryptedQueryParam),
        process.env.REACT_APP_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      const customerData = JSON.parse(decryptedData);
      setBusinessName(customerData.businessName);
      setAddressLine1(customerData.addressLine1);
      setAddressLine2(customerData.addressLine2);
      setState(customerData.state);
      setCity(customerData.city);
      setZipCode(customerData.zipCode);
      setCustomerFirstName(customerData.customerFirstName);
      setCustomerLastName(customerData.customerLastName);
      setEmail(customerData.email);
      setSignFirstName(customerData.signFirstName);
      setSignLastName(customerData.signLastName);
      setSignature(customerData.signature);
      setPassword(customerData.password);
      setConfirmPassword(customerData.password);
      setCustomerId(customerData.customerId);
      setIsLogined(customerData.isLogined);
      var image = new Image();
      image.src = customerData.signature;
      image.onload = function () {
        var canvas = canvasRef.current;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);
      };
    }
  }, []);
  return (
    <>
      <Header />
      <Lodder show={showLodder} />
      <div className="container mt-5 pt-2">
        <div className="row">
          <div className="col-lg-10 mx-auto mt-5">
            <h3 className="heading text-center">
              Multi-Member LLC Builder Registration
            </h3>
            <h4 className="heading text-center">Formation Not Included</h4>
            <p className="text-center">
              Please enter your information below and review our LLC Builder
              Terms of Use and Limited Scope Engagement
            </p>
            <form className="row form-main" onSubmit={handleFormSubmit}>
              <div className="col-lg-12 mb-3">
                <label htmlFor="businessName" className="form-label">
                  Business Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="businessName"
                  aria-describedby="emailHelp"
                  value={businessName}
                  onChange={handleBusinessNameChange}
                />
                <div className="form-text lower-text">
                  If name is not final, enter the current working name
                </div>
                {!businessNameValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {businessNameValidation.message}
                  </span>
                )}
              </div>

              <h6 htmlFor="addressLine1" className="ps-2 form-label">
                Primary Address For the Business
              </h6>

              <div className="col-lg-6 mb-3">
                <label htmlFor="addressLine1" className="form-label">
                  Address Line 1<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="addressLine1"
                  value={addressLine1}
                  onChange={handleAddressLine1Change}
                />
                {!addressLine1Validation.isValid && (
                  <span style={{ color: "red" }}>
                    {addressLine1Validation.message}
                  </span>
                )}
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="addressLine2" className="form-label">
                  Address Line 2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="addressLine2"
                  value={addressLine2}
                  onChange={handleAddressLine2Change}
                />
                {!addressLine2Validation.isValid && (
                  <span style={{ color: "red" }}>
                    {addressLine2Validation.message}
                  </span>
                )}
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="state" className="form-label">
                  State<span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  type="text"
                  className=""
                  id="state"
                  value={state}
                  onChange={handleStateChange}
                  options={usStates}
                />
                {!stateValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {stateValidation.message}
                  </span>
                )}
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="city" className="form-label">
                  City<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  aria-describedby="emailHelp"
                  value={city}
                  onChange={handleCityChange}
                />
                {!cityValidation.isValid && (
                  <span style={{ color: "red" }}>{cityValidation.message}</span>
                )}
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="zipCode" className="form-label">
                  ZIP Code<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="zipCode"
                  aria-describedby="emailHelp"
                  value={zipCode}
                  onChange={handleZipCodeChange}
                />
                {!zipCodeValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {zipCodeValidation.message}
                  </span>
                )}
              </div>
              <h6 className="ps-2">Your Name</h6>
              <div className="col-lg-6 mb-3">
                <label htmlFor="customerFirstName" className="form-label">
                  First Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="customerFirstName"
                  value={customerFirstName}
                  onChange={handleCustomerFirstNameChange}
                  disabled={isLogined}
                />
                {!customerFirstNameValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {customerFirstNameValidation.message}
                  </span>
                )}
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="customerLastName" className="form-label">
                  Last Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="customerLastName"
                  value={customerLastName}
                  onChange={handleCustomerLastNameChange}
                  disabled={isLogined}
                />
                {!customerLastNameValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {customerLastNameValidation.message}
                  </span>
                )}
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="email" className="form-label">
                  Your Email<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  value={email}
                  onChange={handleEmailChange}
                  onBlur={handleEmailBlur}
                  disabled={isLogined}
                />
                {!emailValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {emailValidation.message}
                  </span>
                )}
              </div>
              {!isLogined && (
                <div className="col-lg-6 mb-3">
                  <label htmlFor="password" className="form-label">
                    Password<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={handlePasswordChange}
                    disabled={isLogined}
                  />
                  {!passwordValidation.isValid && (
                    <span style={{ color: "red" }}>
                      {passwordValidation.message}
                    </span>
                  )}
                </div>
              )}
              {!isLogined && (
                <div className="col-lg-6 mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confrimPassword"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    disabled={isLogined}
                  />
                  {!confirmPasswordValidation.isValid && (
                    <span style={{ color: "red" }}>
                      {confirmPasswordValidation.message}
                    </span>
                  )}
                </div>
              )}
            </form>
            <div className="mt-4">
              <h6>
                Foundry Law Group is here to help you build your LLC. We hope
                that you will find our LLC Builder and legal counsel both
                efficient and insightful, freeing you to launch your business
                with confidence that the behind-the-scenes legal is handled.
                Building a business is hard work; forming the company
                shouldn&apos;t be. Welcome to the LLC Builder!
              </h6>
              <p>
                To use our LLC Builder, we ask that you agree to the following
                terms of engagement. These terms of engagement are between
                Foundry Law Group PLLC, and the identified business (or
                yet-to-be-formed) entered on the registration form. The LLC
                Builder is still in beta on select features and technical
                aspects. If you encounter any hiccups or questions, please
                contact us at info@foundrylawgroup.com or reach out directly to
                the managing attorney for your project.
              </p>
              <p>
                <b> Limited Engagement.</b> Upon registration and payment of the
                agreed fees, your named business will be a client of Foundry Law
                Group PLLC. We will be representing the business in connection
                with the LLC Builder and not any of its founders, officers,
                members, managers, agents, or other representatives in their
                individual capacities. Our engagement and the formation of an
                attorney-client relationship will be solely in connection with
                the LLC Builder and those identified deliverables and services.
                After we complete the LLC Builder Scope of Work, the
                attorney-client relationship will be automatically terminated.
                You may of course reach out to us regarding any other legal
                matters and we would be happy to discuss how we may be able to
                help. If we choose to represent you in connection with any other
                legal matter, we will request a new engagement letter at that
                time.
              </p>
              <p>
                It is important to understand that this limited representation
                for the LLC Builder means that we are not legal counsel
                regarding any other aspects of your business, including, but not
                limited to, any defects or other problems arising from a prior
                business formation process, issuances of ownership interests to
                persons other than founders and business partners (for example,
                investors), tax matters, disputes of any nature, trademarks or
                trade names, copyrights, the business plan and any legal
                compliance issues, employment or contracting arrangements,
                website terms of use or privacy policies or practices.{" "}
              </p>
              <p>
                <b>
                  Acknowledgement and Waiver of Potential Conflicts of Interest.{" "}
                </b>
                You understand that Foundry Law Group has represented and
                continues to represent many different businesses and
                individuals. In some cases our representation may have involved,
                or will involve, the firm or its attorneys in matters involving
                individuals associated with your business. So long as our
                representation is substantially unrelated to our LLC Builder
                work for your business, you agree that Foundry Law Group may
                represent existing or new clients in any matter, even if adverse
                to your business, and you waive any such conflict of interest
                that may arise in such circumstance. However, without your
                consent, in no event we will not represent another client in a
                matter adverse to your business if we have obtained confidential
                information of a nonpublic nature from you, as a result of our
                representation of your business, that, if known to the other
                client, could be used to your material disadvantage, unless we
                establish a “screen” to preserve the Company&apos;s confidences.
                You consent to this arrangement.
              </p>
              <p>
                <b>Conflict of Interest Check. </b>Upon your registration for
                the LLC Builder, prior to Foundry Law Group providing legal
                services, we are required to undertake a conflict of interest
                check in order to conform to the applicable rules of
                professional conduct for lawyers. If there is a conflict of
                interest, we may request a waiver or, if not waived or waivable
                for any reason, we will not be able to provide you with legal
                services and will refund any paid fees.{" "}
              </p>
              <p>
                <b>Authorization for Formation of your LLC. </b>By selecting the
                option to have us form your LLC with the State of Washington,
                you authorize Foundry Law Group to act as an authorized agent to
                complete, execute, and deliver a Certificate of Formation and
                Initial Report with the Secretary of the State of Washington.
              </p>
              <p>
                <b>LLC Builder Scope of Work.</b> The scope of services covered
                by the LLC Builder, the "LLC Builder Scope of Work," are those
                services and deliverables listed on the LLC Builder product
                description page under the summary of services. That summary of
                services and deliverable is incorporated into these terms of
                use.
              </p>
              <p>
                <b>Advance Payment of Flat Fees. </b> The LLC Builder is offered
                on a flat fee. Your payment of the legal fees will not be placed
                into a trust account and will be deemed property of Foundry Law
                Group when the payment is received. The fact that you have paid
                the fee in advance does not affect your right to terminate the
                client-lawyer relationship. In the event our relationship is
                terminated before the LLC Builder Scope of Work has been
                completed, you may or may not have a right to a refund of a
                portion of the fee.
              </p>
              <p>
                <b>Advance Payment of Expenses. </b>If you have chosen the
                option to have us file to form your LLC with the State of
                Washington, the advance payment of the filing fees charged by
                the State of Washington are deposited directly into our Foundry
                Law Group client trust account. These funds will be transferred
                to our business account following our payment of those filing
                fees on your behalf.
              </p>
              <p>
                <b>Use and Ownership Rights. </b>You are given rights to use the
                LLC Builder and all of the documents we provide solely in
                connection with your company and its business. The LLC Builder
                is a legal tool designed and operated by Foundry Law Group PLLC.
                We reserve all rights in the LLC Builder, including the form,
                structure, design, and all documents and the contents of all
                documents, instructions, or other material made available
                through the LLC Builder.
              </p>
              <p>
                <b>Restrictions on Use. </b>You may not use the LLC Builder for
                any purpose other than its stated purpose, which is the creation
                of an LLC and development of an operating agreement for a bona
                fide business purpose. You may not use the LLC Builder to (1)
                sell investments in your business to investors, (2) access any
                portion of the LLC Builder tool in order to assist in building a
                competing product or service, or (3) conduct any illegal
                activity (including operation of an unlawful business).
              </p>
              <p>
                <b>Dispute Resolution. </b> In the unlikely event that a dispute
                arises between us stemming from this engagement, we both agree
                to use our best efforts to resolve such disputes in good faith.
                If we are not able to reach a mutual agreement within three
                months of either party giving notice of the dispute, we both
                agree to submit the matter to binding arbitration by a single
                arbitrator in accordance with the rules of JAMS. The arbitration
                shall take place in King County, Washington. We will first
                attempt to agree on a mutually acceptable arbitrator, otherwise,
                we will each appoint an arbitrator who, working together, will
                appoint a third arbitrator to serve as the sole arbiter of the
                dispute. The prevailing party may enter any judgment and award
                rendered by the arbitrator in any court having appropriate
                jurisdiction. The prevailing party may also, at the reasonable
                discretion of the arbitrator, be entitled to compensation for
                attorney&apos;s fees and costs of arbitration if the arbitrator
                determines that the non-prevailing party has not acted in good
                faith.
              </p>
              <p>
                I hereby confirm that I have read, understood, and agree to the
                Terms of Use and Limited Engagement Agreement
                <span style={{ color: "red" }}>*</span>
              </p>
            </div>
            <form className="row mb-3 d-flex align-items-end form-main">
              <div className="col-lg-12 mb-3">
                <canvas
                  ref={canvasRef}
                  width={650}
                  height={80}
                  style={{
                    border: "1px solid #000",
                  }}
                  onMouseDown={startDrawing}
                  onMouseMove={draw}
                  onMouseUp={endDrawing}
                  onMouseOut={endDrawing}
                />
                <div>
                  {!signatureValidation.isValid && (
                    <span style={{ color: "red" }}>
                      {signatureValidation.message}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <a className="btn btn-submit-secondary" onClick={clearCanvas}>
                  CLEAR
                </a>
              </div>

              <div className="row">
                <h6 className="px-2">Signed by</h6>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="signFirstName" className="form-label">
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="signFirstName"
                    aria-describedby="emailHelp"
                    value={signFirstName}
                    onChange={handleSignFirstNameChange}
                  />
                  {!signFirstNameValidation.isValid && (
                    <span style={{ color: "red" }}>
                      {signFirstNameValidation.message}
                    </span>
                  )}
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="signLastName" className="form-label">
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="signLastName"
                    value={signLastName}
                    onChange={handleSignLastNameChange}
                  />
                  {!signLastNameValidation.isValid && (
                    <span style={{ color: "red" }}>
                      {signLastNameValidation.message}
                    </span>
                  )}
                </div>
              </div>
              <div>
                <p>
                  <b>What Happens Next:</b>After registration, you will be asked
                  to enter your payment details. Then you will receive emails
                  confirming your registration and payment and an email with
                  instructions for getting started with the LLC Builder.
                </p>
              </div>
              <div className="col-lg-12 text-end">
                <button
                  className="btn btn-primary submit-button"
                  onClick={handleFormSubmit}
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      {/* <----------------------MODELS-----------------------------> */}
      {/* <-----------------------EMAIL ALREADY EXIST-----------------> */}
      <Modal
        className="email-modal"
        open={model}
        onClose={() => {
          setModal(false);
          setEmail("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div style={{ position: "relative" }}>
              Email Already in Use
              <CloseOutlined
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-10px",
                  color: "black",
                }}
                onClick={() => {
                  setModal(false);
                  setEmail("");
                }}
              />
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            An account already exists with this email address. Would you like to
            log in to your account?
          </Typography>
          <div className="text-end mt-2">
            <Button className="submit-button me-2" onClick={handlelogin}>
              Yes
            </Button>
            <Button
              className="submit-button"
              onClick={() => {
                setModal(false);
                setEmail("");
              }}
            >
              No
            </Button>
          </div>
        </Box>
      </Modal>
      {/* <--------------------LOGIN------------------------------> */}
      <Modal
        className="email-modal"
        open={login}
        onClose={() => {
          setEmail("");
          setLogin(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <input type="hidden" />
            <div className="mb-3">
              <div style={{ position: "relative" }}>
                <label className="form-label" htmlFor="email">
                  Email
                </label>
                <CloseOutlined
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-10px",
                    color: "black",
                  }}
                  onClick={() => {
                    setLogin(false);
                    setEmail("");
                  }}
                />
              </div>
              <input
                className="form-control rounded-1"
                type="email"
                value={email}
                disabled
              />
            </div>
            <div className="mb-3" style={{ position: "relative" }}>
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <input
                className="form-control rounded-1"
                type={showPassword ? "text" : "password"}
                value={loginPassword}
                onChange={handleLoginPasswordChange}
              />
              {showPassword ? (
                <EyeOutlined
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  style={{ position: "absolute", top: "42px", right: "11px" }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  style={{ position: "absolute", top: "42px", right: "11px" }}
                />
              )}
              {!passwordLoginValidation.isValid && (
                <span style={{ color: "red" }}>
                  {passwordLoginValidation.message}
                </span>
              )}
            </div>
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <div className="form-check d-flex align-items-center p-0">
                <Link
                  className="forgot-link text-decoration-none logout-font"
                  to="/forgetpassword"
                >
                  Forgot Password
                </Link>
              </div>
              <button
                type="button"
                className="btn btn-primary d-block submit-button ml-auto"
                onClick={handleLoginFormSubmit}
              >
                LOG IN
              </button>
            </div>
          </form>
        </Box>
      </Modal>
      {/*<------------------------END MODALS--------------------------> */}
    </>
  );
};

export default MultiMemberLLCRegister;
